<div class="container">
  <div class="todo-box">
    <div class="add-row">
      <input
        class="itemNameText"
        type="text"
        name="itemName"
        #itemName
        placeholder="Please enter here"
      />
      <button
        class="btn btn-lg btn-primary add-button"
        (click)="addItem(itemName.value); itemName.value='';"
      >
        Add
      </button>
      <button
        class="btn btn-lg btn-warn add-button" style="background-color: #a98037;"
        (click)="reset(); itemName.value='';"
      >
        Reset
      </button>
    </div>
    <div class="checklist">
      <div *ngFor="let item of items">
        <input
          type="checkbox"
          name="itemCheckBox"
          (change)="refreshList($event, item)"
        />
        {{ item }}
      </div>
    </div>
    <hr
      style="
        height: 1px;
        border-width: 0;
        color: rgb(44, 44, 44);
        background-color: gray;
      "
    />
    <div class="checked">
      <div *ngFor="let checkedItem of itemsChecked">
        <input
          type="checkbox"
          name="itemsChecked"
          checked="true"
          (change)="refreshList($event, checkedItem)"
        /><s>{{ checkedItem }}</s>
      </div>
    </div>
  </div>
</div>
